import { createFileRoute, notFound } from '@tanstack/react-router'

/**
 * DEV-ONLY error-page test trigger — throws from the loader so the router's
 * `defaultErrorComponent` (src/components/ErrorPage.tsx) renders. In
 * production builds this route 404s (it effectively doesn't exist).
 *
 *   /debug-error             → 500 page
 *   /debug-error?status=403  → 403 page (any 4xx/5xx works)
 */
export const Route = createFileRoute('/debug-error')({
  validateSearch: (s: Record<string, unknown>): { status?: number } => {
    // The router JSON-parses search values, so ?status=403 arrives as a number.
    const n = Number(s.status)
    return { status: Number.isFinite(n) && n > 0 ? n : undefined }
  },
  loaderDeps: ({ search }) => ({ status: search.status }),
  loader: ({ deps }) => {
    if (!import.meta.env.DEV) throw notFound()
    throw Object.assign(new Error('debug-error test throw'), {
      status: deps.status ?? 500,
    })
  },
  component: () => null,
})
